export const RevenueExpenditure = {
    POINTHISTORY: '收支明细',
    SIGNINHISTORY: '签到明细',
}